import axios from 'axios';

const STORAGE_KEY = 'pageAccess';

export const ACCESS_LEVELS = [
    { value: 'none', label: 'Нет', color: 'default' },
    { value: 'view', label: 'Просмотр', color: 'blue' },
    { value: 'edit', label: 'Редактирование', color: 'orange' },
    { value: 'full', label: 'Полные', color: 'green' }
];

export const ACCESS_RANK = {
    none: 0,
    view: 1,
    edit: 2,
    full: 3
};

export const canAtLeast = (level, need = 'view') =>
    (ACCESS_RANK[level] || 0) >= (ACCESS_RANK[need] || 0);

export const getCachedPageAccess = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (_) {
        return null;
    }
};

export const setCachedPageAccess = accessMap => {
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(accessMap || {})
    );
    window.dispatchEvent(new Event('page-access'));
};

export const clearCachedPageAccess = () => {
    localStorage.removeItem(STORAGE_KEY);
};

export const loadMyPageAccess = async () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const { data } = await axios.get('/api/page-access/my', {
        headers: { Authorization: `Bearer ${token}` }
    });

    const access = data?.data?.access || {};
    setCachedPageAccess(access);
    return data.data;
};

export const pathToPageKey = pathname => {
    const path = String(pathname || '').split('?')[0];
    const map = [
        ['/task-manager/field-permissions', 'task-manager-field-permissions'],
        ['/task-manager/access', 'task-manager-access'],
        ['/task-manager/stage-routes', 'task-manager-stage-routes'],
        ['/task-manager/work-type-stages', 'task-manager-work-type-stages'],
        ['/task-manager/settings', 'task-manager-settings'],
        ['/task-manager/dictionaries', 'task-manager-dictionaries'],
        ['/task-manager/fields', 'task-manager-fields'],
        ['/task-manager/statuses', 'task-manager-statuses'],
        ['/task-manager/organizations', 'task-manager-organizations'],
        ['/task-manager/sites', 'task-manager-sites'],
        ['/task-manager/projects', 'task-manager-projects'],
        ['/task-manager', 'task-manager'],
        ['/customer-cabinet', 'customer-cabinet'],
        ['/bitrix-analytics', 'bitrix-analytics'],
        ['/bitrix-tasks', 'bitrix-tasks'],
        ['/calendar', 'calendar'],
        ['/hr/deals', 'hr-deals'],
        ['/hr/staff-registry', 'hr-staff-registry'],
        ['/user-activity', 'user-activity'],
        ['/max-messenger', 'max-messenger'],
        ['/keyword-watch', 'keyword-watch'],
        ['/org-structure', 'org-structure'],
        ['/goskey', 'goskey'],
        ['/customer-order-compare', 'customer-order-compare'],
        ['/bp-closing', 'bp-closing'],
        ['/subcontracts', 'subcontracts'],
        ['/tmc', 'tmc'],

        ['/financial-articles', 'financial-articles'],
        ['/templates-incomerce', 'templates-incomerce'],
        ['/route-calculator', 'route-calculator'],
        ['/transcription', 'transcription'],
        ['/daily-reports', 'daily-reports'],
        ['/counterparties', 'counterparties'],
        ['/nomenclature', 'nomenclature'],
        ['/price-types', 'price-types'],
        ['/constructor', 'constructor'],
        ['/registries', 'registries'],
        ['/doc-workflows', 'doc-workflows'],
        ['/invoice-approval', 'invoice-approval'],
        ['/chat', 'chat'],
        ['/edit-stat', 'edit-stat'],
        ['/dashboard', 'dashboard'],
        ['/invoices', 'invoices'],
        ['/priveleg', 'priveleg'],
        ['/installer', 'installer'],
        ['/users', 'users'],
        ['/tasks', 'tasks'],
        ['/docs', 'docs']
    ];

    for (const [prefix, key] of map) {
        if (path === prefix || path.startsWith(`${prefix}/`)) {
            return key;
        }
    }
    return null;
};

export const hasPageAccess = (pageKey, need = 'view') => {
    if (!pageKey) return true;
    const access = getCachedPageAccess();
    if (!access) return null;
    return canAtLeast(access[pageKey], need);
};
